export default __webpack_public_path__ + "static/media/essa.d714f5bd.png";